import { render, staticRenderFns } from "./CreateStudioLocation.vue?vue&type=template&id=335b658f&scoped=true"
import script from "./CreateStudioLocation.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateStudioLocation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateStudioLocation.vue?vue&type=style&index=0&id=335b658f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335b658f",
  null
  
)

export default component.exports